<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import {
  SectionHeading,
  SectionHeadingShapeInt
} from '@toni/brand-ui'

import RelatedArticles from '../../../../../components/content-blocks/related-article-block/base/RelatedArticles.vue'

defineProps<{
    id: string
  }>()

const { t } = useI18n()

</script>

<template>
  <RelatedArticles :id="id">
    <template #headline>
      <div class="flex flex-row items-center space-x-2 sm:space-x-2.5 md:space-x-3 lg:space-x-3.5">
        <SectionHeadingShapeInt variant="tertiary" />
        <SectionHeading :uppercase="false"
                        class="text-heading-display-xxs sm:text-heading-display-xs md:text-heading-display-xs lg:text-heading-display-sm">
          {{ t('teaser.related.headline') }}
        </SectionHeading>
      </div>
    </template>
  </RelatedArticles>
</template>
